<template>
  <div class="user_container">
    <div class="top_content">
      <div class="user_top1">
        <div class="header_con">
          <i class="el-icon-arrow-left" @click="goBack"></i>
          <span @click="goBack">消息列表</span>
        </div>
      </div>
      <div class="content_list">
        <van-list
          v-model="loadingTwo"
          :finished="finishedTwo"
          finished-text="没有更多了"
          @load="onLoadTwo"
          :immediate-check="false"
        >
          <div
            class="list_item"
            v-for="(item, index) in listTwo1"
            :key="index"
            @click="handleCheckDetail(item)"
          >
            <div class="item_top">
              <img
                class="img"
                src="@/assets/newsNotice/icon7.png"
                alt=""
                v-if="item.cardType == 1"
              />
              <img
                class="img"
                src="@/assets/newsNotice/icon8.png"
                alt=""
                v-if="item.cardType == 2"
              />
              <img
                class="img"
                src="@/assets/newsNotice/icon14.png"
                alt=""
                v-if="item.cardType == 3"
              />
              <img
                class="img"
                src="@/assets/newsNotice/icon15.png"
                alt=""
                v-if="item.cardType == 4"
              />
              <div class="date">{{ item.createDateFormat }}</div>
            </div>
            <div class="item_center">
              <div class="item_title item_title1">{{ item.sendername }}</div>
              <div class="item_con">
                {{ item.type == 0 ? "点赞卡" : item.medalName }}
              </div>
              <div class="item_title item_title2">{{ $store.state.userInfo.nickname }}</div>
              <!-- <div class="item_title">{{ item.receivername }}</div> -->
            </div>
            <div class="point_con" v-if="item.point">+{{ item.point }}分</div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import moment from "moment";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "facility",
  props: {},

  data() {
    return {
      listTwo1: [],
      loadingTwo: false,
      finishedTwo: false,
      totalAllTwo1: 0,
      pageTwo: 1,
      empno: "",
      pageSize: 20
    };
  },

  created() {},
  computed: {},
  mounted() {
    let hrToken = getToken();
    //获取token
    if (hrToken) {
      this.empno = hrToken;
      this.getBadgeListTwo();
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          this.getBadgeListTwo();
        });
      });
    }
  },
  methods: {
    //获取token&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            // console.log(data);
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //返回上一页
    goBack() {
      this.$router.back();
    },
    onLoadTwo() {
      this.getBadgeListTwo();
    },
    //获取消息列表
    getBadgeListTwo() {
      api
        .medalCardRevApi({
          page: this.pageTwo,
          pageSize: this.pageSize,
          recordType: "1",
          flagType: "1",
          empno: this.empno,
          hrAuthToken: window.sessionStorage.hrToken
        })
        .then(res => {
          if (res.code == 200) {
            this.totalAllTwo1 = res.total;
            this.finishedTwo = false;
            if (this.pageTwo === 1) {
              this.listTwo1 = res.data;
            } else {
              this.listTwo1 = this.listTwo1.concat(res.data);
            }
            if (this.listTwo1.length < this.totalAllTwo1) {
              this.pageTwo = this.pageTwo + 1;
            } else {
              this.finishedTwo = true;
            }
            this.listTwo1.forEach(item => {
              item.created = moment(item.created).format("YYYY-MM-DD");
            });
            this.loadingTwo = false;
          }
        });
    },
    //跳转勋章&点赞卡详情
    handleCheckDetail(item) {
      // if (item.type == 0) {
      //   this.$router.push({
      //     path: "/mobile/medal/quaquakaDetail",
      //     query: {
      //       id: item.id
      //     }
      //   });
      // }
      // if (item.type == 1) {
      //   this.$router.push({
      //     path: "/mobile/medal/badgeDetail",
      //     query: {
      //       id: item.id
      //     }
      //   });
      // }
      if (item.cardType == 1) {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: item.id
          }
        });
      }
      if (item.cardType == 3) {
        this.$router.push({
          path: "/mobile/medal/badgeDetail",
          query: {
            id: item.id
          }
        });
      }
      if (item.cardType == 2) {
        this.$router.push({
          path: "/mobile/medal/newsNotice/medalDetail",
          query: {
            id: item.id
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  min-height: 100vh;
  position: relative;
  margin: auto;
  font-size: 1vh;
  background-color: #f7f9fa;

  .user_top1 {
    background-image: url("../../../assets/newsNotice/background.png");
    background-size: 100% 100%;
    height: 580px;
    .header_con {
      height: 120px;
      line-height: 120px;
      font-weight: bold;
      font-size: 34px;
      color: #282b32;
      padding: 0 30px;
      span {
        margin-left: 20px;
      }
      ::v-deep {
        .el-icon-arrow-left {
          font-weight: bold;
        }
      }
    }
  }

  .content_list {
    width: 100%;
    height: calc(100vh - 120px);
    overflow-y: auto;
    position: absolute;
    top: 120px;
    padding: 0 30px;
    border-radius: 16px;
    &::-webkit-scrollbar {
      display: none;
    }
    .list_item {
      background-color: #fff;
      height: 178px;
      margin-bottom: 22px;
      .item_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img {
          width: 125px;
          height: 47px;
        }
        .date {
          font-weight: 400;
          font-size: 22px;
          color: #969b9e;
          margin-right: 20px;
        }
      }
      .item_center {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 10px 0;
        .item_title {
          flex-shrink: 0;
          font-weight: bold;
          font-size: 34px;
          color: #282b32;
          width: 28%;
          
          // overflow: hidden; /* 隐藏溢出内容 */
          // white-space: nowrap; /* 不换行 */
          // text-overflow: ellipsis; /* 显示省略号 */
        }
        .item_title1{
          text-align: right;
        }
        .item_title2{
          text-align: left;
        }
        .item_con {
          display: flex;
          flex-wrap: nowrap;
          flex-shrink: 0;
          font-weight: 400;
          font-size: 26px;
          color: #4ea27c;
          border-radius: 10px;
          border: 2px solid #4ea27c;
          padding: 3px 20px;
          position: relative;
          margin: 0 65px;
          &::before {
            content: "";
            display: inline-block;
            width: 58px;
            height: 6px;
            background-image: url("~@/assets/newsNotice/icon9.png");
            background-size: 100% 100%;
            position: absolute;
            top: 40%;
            left: -58px;
            transform: translate(-50% -50%);
          }
          &::after {
            content: "";
            display: inline-block;
            width: 58px;
            height: 6px;
            background-image: url("~@/assets/newsNotice/icon10.png");
            background-size: 100% 100%;
            position: absolute;
            top: 40%;
            right: -58px;
            transform: translate(-50% -50%);
          }
        }
      }
      .point_con {
        text-align: center;
        font-weight: bold;
        font-size: 26px;
        color: #282b32;
      }
    }
  }
}
</style>
